// extracted by mini-css-extract-plugin
export default {"content":"categoryListContainer_content__zd6fI"};